import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StatusLabelComponent } from '@principle-theorem/ng-principle-shared';

@Component({
  selector: 'pr-checklist-item-status',
  templateUrl: './checklist-item-status.component.html',
  styleUrls: ['./checklist-item-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusLabelComponent],
})
export class ChecklistItemStatusComponent {
  @Input() isDone?: boolean;

  get statusColor(): string {
    return this.isDone ? 'primary' : 'default';
  }

  get statusLabel(): string {
    return this.isDone ? 'completed' : 'pending';
  }
}
